import { SDK } from 'sdk';

import { AttachmentErrorsStore } from './attachmentErrorsStore';
import { ClientViewportStore } from './clientViewportStore';
import { DateDelimiterStore } from './dateDelimiterStore';
import { DraggablePositionStore } from './draggablePositionStore';
import { LoadingStore } from './loadingStore';
import { ModalStore } from './modalStore';
import { ScrollStore } from './scrollStore';

export class UIState {
	modalStore: ModalStore;
	scrollStore: ScrollStore;
	loadingStore: LoadingStore;
	clientViewport: ClientViewportStore;
	dateDelimiterStore: DateDelimiterStore;
	attachmentErrorsStore: AttachmentErrorsStore;
	draggablePositionStore: DraggablePositionStore;
	constructor(sdk: SDK) {
		this.modalStore = new ModalStore(sdk);
		this.attachmentErrorsStore = new AttachmentErrorsStore(sdk);
		this.loadingStore = new LoadingStore(sdk);
		this.scrollStore = new ScrollStore(sdk, this.loadingStore);
		this.dateDelimiterStore = new DateDelimiterStore(this.scrollStore);
		this.clientViewport = new ClientViewportStore();
		this.draggablePositionStore = new DraggablePositionStore(this.clientViewport, sdk.uiStateStore);
	}
}
